import { apiClient } from './apiClient';
import { authService } from './authService';

const SUBSCRIPTION_API_BASE = '/api/subscriptions';

export const subscriptionService = {
  // ==================== CMMS Subscriptions ====================

  // Get CMMS subscription for current company
  async getCmmsSubscription() {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.get(`${SUBSCRIPTION_API_BASE}/cmms/company/${companyId}`);
  },

  // Get all available CMMS plans
  async getCmmsPlans() {
    return apiClient.get(`${SUBSCRIPTION_API_BASE}/cmms/plans`);
  },

  // Get CMMS plan by ID
  async getCmmsPlanById(planId) {
    return apiClient.get(`${SUBSCRIPTION_API_BASE}/cmms/plans/${planId}`);
  },

  // Upgrade CMMS subscription to a new plan
  async upgradeCmmsPlan(planId) {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.put(`${SUBSCRIPTION_API_BASE}/cmms/${companyId}/upgrade?newPlanId=${planId}`);
  },

  // Cancel CMMS subscription
  async cancelCmmsSubscription() {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.delete(`${SUBSCRIPTION_API_BASE}/cmms/${companyId}`);
  },

  // ==================== Chatbot Subscriptions ====================

  // Get Chatbot subscription for current company
  async getChatbotSubscription() {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.get(`${SUBSCRIPTION_API_BASE}/chatbot/company/${companyId}`);
  },

  // Get all available Chatbot plans
  async getChatbotPlans() {
    return apiClient.get(`${SUBSCRIPTION_API_BASE}/chatbot/plans`);
  },

  // Upgrade Chatbot subscription to a new plan
  async upgradeChatbotPlan(planId) {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.put(`${SUBSCRIPTION_API_BASE}/chatbot/${companyId}/upgrade?newPlanId=${planId}`);
  },

  // Cancel Chatbot subscription
  async cancelChatbotSubscription() {
    const companyId = authService.getCompanyId();
    if (!companyId) {
      throw new Error('No company ID found');
    }
    return apiClient.delete(`${SUBSCRIPTION_API_BASE}/chatbot/${companyId}`);
  },

  // ==================== Helpers ====================

  // Get all subscriptions for current company
  async getAllSubscriptions() {
    const hasCmms = localStorage.getItem('hasCmmsSubscription') === 'true';
    const hasChatbot = localStorage.getItem('hasChatbotSubscription') === 'true';

    const results = {
      cmms: null,
      chatbot: null
    };

    try {
      if (hasCmms) {
        results.cmms = await this.getCmmsSubscription();
      }
    } catch (err) {
      console.error('Error fetching CMMS subscription:', err);
    }

    try {
      if (hasChatbot) {
        results.chatbot = await this.getChatbotSubscription();
      }
    } catch (err) {
      console.error('Error fetching Chatbot subscription:', err);
    }

    return results;
  },

  // Calculate days remaining for trial
  calculateTrialDaysRemaining(trialEndDate) {
    if (!trialEndDate) return null;
    const endDate = new Date(trialEndDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  },

  // Check if trial has expired
  isTrialExpired(trialEndDate) {
    if (!trialEndDate) return false;
    const daysRemaining = this.calculateTrialDaysRemaining(trialEndDate);
    return daysRemaining !== null && daysRemaining < 0;
  }
};
